"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableBarChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var PluggableColumnBarCharts_1 = require("../PluggableColumnBarCharts");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var BarChartConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/BarChartConfigurationPanel"));
var axis_1 = require("../../../constants/axis");
var SortConfig_1 = require("../../../interfaces/SortConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var sortHelpers_1 = require("./sortHelpers");
var PluggableBarChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableBarChart, _super);
    function PluggableBarChart(props) {
        var _this = _super.call(this, props) || this;
        _this.secondaryAxis = axis_1.AXIS_NAME.SECONDARY_X;
        _this.type = sdk_ui_1.VisualizationTypes.BAR;
        _this.defaultControlsProperties = {
            stackMeasures: false,
        };
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableBarChart.prototype.getSupportedPropertiesList = function () {
        return supportedProperties_1.BAR_CHART_SUPPORTED_PROPERTIES[this.axis || axis_1.AXIS.DUAL] || [];
    };
    PluggableBarChart.prototype.renderConfigurationPanel = function (insight) {
        if (document.querySelector(this.configPanelElement)) {
            react_dom_1.render(react_1.default.createElement(BarChartConfigurationPanel_1.default, { locale: this.locale, colors: this.colors, references: this.references, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, pushData: this.handlePushData, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags, axis: this.axis }), document.querySelector(this.configPanelElement));
        }
    };
    PluggableBarChart.prototype.getDefaultAndAvailableSort = function (referencePoint, canSortStackTotalValue) {
        var buckets = referencePoint.buckets;
        var measures = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.MEASURES);
        var viewBy = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.VIEW);
        var stackBy = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.STACK);
        if (viewBy.length === 2) {
            if (measures.length >= 2 && !canSortStackTotalValue) {
                return {
                    currentSort: [
                        sdk_model_1.newAttributeAreaSort(viewBy[0].localIdentifier, "desc"),
                        sdk_model_1.newMeasureSort(measures[0].localIdentifier, "desc"),
                    ],
                    availableSorts: [
                        {
                            itemId: sdk_model_1.localIdRef(viewBy[0].localIdentifier),
                            attributeSort: {
                                normalSortEnabled: true,
                                areaSortEnabled: true,
                            },
                        },
                        {
                            itemId: sdk_model_1.localIdRef(viewBy[1].localIdentifier),
                            attributeSort: {
                                normalSortEnabled: true,
                                areaSortEnabled: true,
                            },
                            metricSorts: tslib_1.__spreadArrays(measures.map(function (m) { return SortConfig_1.newMeasureSortSuggestion(m.localIdentifier); })),
                        },
                    ],
                };
            }
            return {
                currentSort: [
                    sdk_model_1.newAttributeAreaSort(viewBy[0].localIdentifier, "desc"),
                    sdk_model_1.newAttributeAreaSort(viewBy[1].localIdentifier, "desc"),
                ],
                availableSorts: [
                    {
                        itemId: sdk_model_1.localIdRef(viewBy[0].localIdentifier),
                        attributeSort: {
                            normalSortEnabled: true,
                            areaSortEnabled: true,
                        },
                    },
                    {
                        itemId: sdk_model_1.localIdRef(viewBy[1].localIdentifier),
                        attributeSort: {
                            normalSortEnabled: true,
                            areaSortEnabled: true,
                        },
                        metricSorts: tslib_1.__spreadArrays(measures.map(function (m) { return SortConfig_1.newMeasureSortSuggestion(m.localIdentifier); })),
                    },
                ],
            };
        }
        if (!isEmpty_1.default(viewBy) && (!isEmpty_1.default(stackBy) || canSortStackTotalValue)) {
            return {
                currentSort: [sdk_model_1.newAttributeAreaSort(viewBy[0].localIdentifier, "desc")],
                availableSorts: [
                    {
                        itemId: sdk_model_1.localIdRef(viewBy[0].localIdentifier),
                        attributeSort: {
                            normalSortEnabled: true,
                            areaSortEnabled: true,
                        },
                    },
                ],
            };
        }
        if (!isEmpty_1.default(viewBy) && !isEmpty_1.default(measures)) {
            return {
                currentSort: [sdk_model_1.newMeasureSort(measures[0].localIdentifier, "desc")],
                availableSorts: [
                    {
                        itemId: sdk_model_1.localIdRef(viewBy[0].localIdentifier),
                        attributeSort: {
                            normalSortEnabled: true,
                            areaSortEnabled: false,
                        },
                        metricSorts: tslib_1.__spreadArrays(measures.map(function (m) { return SortConfig_1.newMeasureSortSuggestion(m.localIdentifier); })),
                    },
                ],
            };
        }
        return {
            currentSort: [],
            availableSorts: [],
        };
    };
    PluggableBarChart.prototype.getSortConfig = function (referencePoint) {
        var buckets = referencePoint.buckets;
        var viewBy = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.VIEW);
        var measures = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.MEASURES);
        var disabled = viewBy.length < 1 || measures.length < 1;
        var currentSort = this.getDefaultAndAvailableSort(referencePoint, sortHelpers_1.canSortStackTotalValue(referencePoint.buckets, referencePoint.properties)).currentSort;
        return Promise.resolve({
            supported: true,
            disabled: disabled,
            currentSort: currentSort,
            availableSorts: [],
        });
    };
    return PluggableBarChart;
}(PluggableColumnBarCharts_1.PluggableColumnBarCharts));
exports.PluggableBarChart = PluggableBarChart;
//# sourceMappingURL=PluggableBarChart.js.map